module.exports = __webpack_public_path__ + "3e07f3b098a345d016ade2034021e125.woff2";